import './CourseBenefits.scss';
import icons from '@assets/icons/redesign';

const { StarStroke } = icons;

export default function CourseBenefits({ title, items }) {
  return (
    <div className="courseBenefits">
      <h2 className="courseBenefits-title">{title}</h2>
      <ul className="courseBenefits-list">
        {items.map((item, idx) => (
          <li className="courseBenefits-list-item" key={idx}>
            <StarStroke className="courseBenefits-list-item-icon" />
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
